export default __webpack_public_path__ + "static/media/sam-and-karen-gondola.53d06df8.jpeg";